(() => {
  if (customElements.get('maoni-cord-starter-accessories')) return;

  const normalize = (value = '') => String(value)
    .toLocaleLowerCase('de-DE')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const colorKey = (value = '') => {
    const text = normalize(value);
    if (text.includes('dunkeltaupe')) return 'dunkeltaupe';
    if (text.includes('dunkelgrau')) return 'dunkelgrau';
    if (text.includes('schwarz')) return 'schwarz';
    if (text.includes('beige')) return 'beige';
    if (text.includes('blau')) return 'dunkelblau';
    if (text.includes('braun') || text.includes('cognac')) return 'cognac';
    return '';
  };

  const colorLabel = (key) => ({
    beige: 'Beige',
    dunkeltaupe: 'Dunkeltaupe',
    dunkelgrau: 'Dunkelgrau',
    schwarz: 'Schwarz',
    dunkelblau: 'Blau',
    cognac: 'Braun'
  }[key] || '');

  class MaoniCordStarterAccessories extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.configurator = this.querySelector('maoni-set-configurator');
      this.productRoot = this.closest('product-form');
      this.boundVariantChange = (event) => {
        if (event.detail?.variant) this.applyVariant(event.detail.variant);
      };
      this.productRoot?.addEventListener('on:variant:change', this.boundVariantChange);

      const initialVariant = this.configurator?.currentBagVariant || {
        option1: this.dataset.initialShoulderColor,
        option2: this.dataset.initialBagColor,
        option3: this.dataset.initialEtuiColor
      };
      this.applyVariant(initialVariant);
    }

    disconnectedCallback() {
      this.productRoot?.removeEventListener('on:variant:change', this.boundVariantChange);
    }

    optionValue(variant, index) {
      if (Array.isArray(variant?.options)) return variant.options[index - 1] || '';
      return variant?.[`option${index}`] || '';
    }

    applyVariant(variant) {
      const shoulderKey = colorKey(this.optionValue(variant, 1));
      const bagKey = colorKey(this.optionValue(variant, 2));
      const activeGroups = new Set([shoulderKey, bagKey].filter(Boolean));
      const includedEtui = normalize(this.optionValue(variant, 3)).replace(/^etui\s+/, '');
      const renderedVariants = new Set();

      this.querySelectorAll('[data-maoni-variant-group]').forEach((card) => {
        const input = card.querySelector('input[data-maoni-accessory]');
        const groupIsActive = activeGroups.has(card.dataset.maoniVariantGroup || '');
        const isIncludedEtui = input?.dataset.maoniAccessory === 'etui'
          && normalize(input.dataset.variantTitle).replace(/^etui\s+/, '') === includedEtui;
        const variantKey = input ? `${input.dataset.maoniAccessory || 'extra'}:${input.value}` : '';
        const isDuplicate = Boolean(groupIsActive && !isIncludedEtui && variantKey && renderedVariants.has(variantKey));
        const shouldShow = Boolean(input && groupIsActive && !isIncludedEtui && !isDuplicate);

        card.hidden = !shouldShow;
        if (!input) return;
        input.disabled = !shouldShow;
        if (!shouldShow) input.checked = false;
        if (shouldShow && variantKey) renderedVariants.add(variantKey);
      });

      this.updateBestsellerBadge();
      this.updateActiveColorLabel(shoulderKey, bagKey);
      if (this.configurator) {
        this.configurator.dataset.maoniActiveVariantGroup = [shoulderKey, bagKey].filter(Boolean).join(',');
        if (typeof this.configurator.updateSummary === 'function') this.configurator.updateSummary();
      }
      this.resetAccessoryScroll();
    }

    resetAccessoryScroll() {
      const scroller = this.querySelector('.maoni-wildleder-configurator__straps');
      if (!scroller) return;

      const reset = () => {
        scroller.scrollLeft = 0;
      };

      reset();
      if (typeof requestAnimationFrame === 'function') requestAnimationFrame(reset);
    }

    updateBestsellerBadge() {
      this.querySelectorAll('.maoni-wildleder-strap-card__badge').forEach((badge) => {
        badge.hidden = true;
      });
      this.querySelectorAll('.maoni-starter-bundle__dynamic-bestseller').forEach((badge) => badge.remove());

      const firstStrap = Array.from(this.querySelectorAll('[data-maoni-variant-group]'))
        .find((card) => !card.hidden && card.querySelector('input[data-maoni-accessory="strap"]'));
      if (!firstStrap) return;

      const existingBadge = firstStrap.querySelector('.maoni-wildleder-strap-card__badge');
      if (existingBadge) {
        existingBadge.hidden = false;
        return;
      }

      const badge = document.createElement('span');
      badge.className = 'maoni-wildleder-strap-card__badge maoni-starter-bundle__dynamic-bestseller';
      badge.textContent = 'Bestseller';
      firstStrap.appendChild(badge);
    }

    updateActiveColorLabel(shoulderKey, bagKey) {
      const label = this.querySelector('[data-maoni-starter-active-colors]');
      if (!label) return;
      const labels = [...new Set([colorLabel(shoulderKey), colorLabel(bagKey)].filter(Boolean))];
      label.textContent = labels.length
        ? `Passende Extras für: ${labels.join(' + ')}`
        : 'Passende Extras für deine beiden Taschenfarben';
    }
  }

  customElements.define('maoni-cord-starter-accessories', MaoniCordStarterAccessories);
})();
